class FlexaConverterColors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeProperties();
    this.setupEventListeners();
  }

  initializeProperties() {
    this.converterColors = this.parseColorsData();
    this.domElements = {
      colorContainer: this.querySelector("[data-color-container]"),
      nameElement: this.querySelector("[data-selected-color-name]"),
      descriptionElement: this.querySelector("[data-selected-color-description]"),
    };
    this.initialName = this.domElements.nameElement.textContent;
    this.initialDescription = this.domElements.descriptionElement.textContent;
    this.colorTranslation = window.theme.converterStrings.colorTranslation;
  }

  parseColorsData() {
    return JSON.parse(this.querySelector("[data-colors]").innerText);
  }

  setupEventListeners() {
    document.addEventListener("collection-selected", (event) =>
      this.handleCollectionSelected(event.detail)
    );
  }

  handleCollectionSelected(selectedCollection) {
    this.resetDisplay();
    const colorsToRender = this.getColorsToRender(selectedCollection);
    this.renderColors(colorsToRender);
  }

  resetDisplay() {
    this.domElements.nameElement.textContent = this.initialName;
    this.domElements.descriptionElement.textContent = this.initialDescription;
  }

  getColorsToRender(selectedCollection) {
    const colorsInCollection = this.extractUniqueColors(selectedCollection);
    const matchingColors = this.filterMatchingColors(colorsInCollection);

    if (matchingColors.length < 1) {
      this.hideAndDispatchNullColor();
      return [];
    } else if (matchingColors.length == 1) {
      this.hideAndDispatchFirstColor(matchingColors);
      return [];
    }

    return matchingColors;
  }

  extractUniqueColors(collection) {
    return new Set(
      collection.products
        .filter((product) => this.isValidProduct(product))
        .map((product) => product[this.colorTranslation].property.toLowerCase())
    );
  }

  isValidProduct(product) {
    return product[this.colorTranslation] && product.product.tags.includes("BED");
  }

  hideAndDispatchNullColor() {
    this.hidden = true;
    this.dispatchColorSelected(null);
  }

  hideAndDispatchFirstColor(mathcingColors) {
    this.hidden = true;
    setTimeout(() => this.saveAndDispatchColor(mathcingColors[0]), 50);
  }

  filterMatchingColors(colorsInCollection) {
    return this.converterColors.filter((color) => this.isColorMatch(color, colorsInCollection));
  }

  isColorMatch({ color_name, mergers }, colorsInCollection) {
    const lowercaseName = color_name.toLowerCase();
    return (
      colorsInCollection.has(lowercaseName) ||
      (mergers && mergers.some((merger) => colorsInCollection.has(merger.toLowerCase())))
    );
  }

  renderColors(colors) {
    if (colors.length === 0) return;

    const colorElements = this.buildColorElements(colors);
    this.updateColorContainer(colorElements);
    this.attachColorEventListeners();
    this.hidden = false;
  }

  buildColorElements(colors) {
    const htmlString = colors.map((color) => this.generateColorHtml(color)).join("");
    return this.parseHtmlToElements(htmlString);
  }

  generateColorHtml(color) {
    return `
      <input
        type="radio"
        class="flexa-converter__color__radio"
        name="color--group"
        data-color-name="${color.color_name}"
        id="color--${color.color_name}"
      >
      <label 
        for="color--${color.color_name}" 
        class="flex-converter__color" 
        style="background-color: ${color.color};"
      ></label>
    `;
  }

  parseHtmlToElements(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return Array.from(doc.body.children);
  }

  updateColorContainer(elements) {
    this.domElements.colorContainer.replaceChildren(...elements);
  }

  attachColorEventListeners() {
    const colorInputs = this.domElements.colorContainer.querySelectorAll(
      'input[name="color--group"]'
    );
    colorInputs.forEach((input) => {
      input.addEventListener("click", (event) => this.handleColorSelection(event));
    });
  }

  handleColorSelection(event) {
    const selectedColor = this.findColorByName(event.target.dataset.colorName);
    this.updateDisplay(selectedColor);
    this.saveAndDispatchColor(selectedColor);
  }

  findColorByName(colorName) {
    return this.converterColors.find(
      (color) => color.color_name.toLowerCase() === colorName.toLowerCase()
    );
  }

  updateDisplay(color) {
    this.domElements.nameElement.textContent = color.color_name;
    this.domElements.descriptionElement.textContent = color.description;
  }

  saveAndDispatchColor(color) {
    sessionStorage.setItem("current-color", JSON.stringify(color));
    this.dispatchColorSelected(color);
  }

  dispatchColorSelected(color) {
    document.dispatchEvent(new CustomEvent("color-selected", { detail: color }));
  }
}

customElements.define("flexa-converter-colors", FlexaConverterColors);
